import React from 'react';
import {
  Link,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { resolveTo } from '~/commons/helpers';

const Header = ({
  breadcrumb,
  children,
}) => {
  const { t } = useTranslation();

  return (
  <header className="pt-5 pb-3">
    {breadcrumb && (
      <nav>
        <div className="breadcrumb">
          {breadcrumb.map((b, i) => (
            <div key={i} className="breadcrumb-item">
              <Link to={resolveTo(b.to)}>
                {t(b.children)}
              </Link>
            </div>
          ))}
        </div>
      </nav>
    )}
    <h1>{t(children)}</h1>
  </header>
  );
};
export default Header;
